// Factory binding the generic SignRuleSignalTab to one fund slug, so fundPages.ts keeps the uniform
// `{ ctx }` signalTab contract (SignalTabCtx carries no fund). Functional component: no state of its own.
import { h, type Component } from 'vue'
import SignRuleSignalTab from './SignRuleSignalTab.vue'
import type { SignalTabCtx } from '../nav/fundPages'
import type { PortfolioSlug } from '../nav/fundConfig'

export function signRuleTab(slug: PortfolioSlug): Component {
  const Tab = (props: { ctx: SignalTabCtx }) => h(SignRuleSignalTab, { ctx: props.ctx, slug })
  Tab.props = ['ctx']
  return Tab as unknown as Component
}
